import { useCheckEmailMutation } from "api/User/hooks.ts";
import { useState } from "react";
import { CheckEmailStatus, RoleEnum } from "types/enums.ts";

// Intentionally mirrors AffiliateRegistrationForm/useTenantCheckEmail — duplicated on purpose, keep both in sync.

export function useTenantCheckEmail(tenantId: string) {
    const [status, setStatus] = useState<CheckEmailStatus | "idle">("idle");
    const [nickname, setNickname] = useState<string | null>(null);

    const checkEmailMutation = useCheckEmailMutation({
        onSuccess: (response) => {
            setStatus(response?.status ?? "idle");
            setNickname(response?.nickname ?? null);
        },
        onError: () => {
            setStatus("idle");
            setNickname(null);
        },
    });

    const checkEmail = (email: string, role: RoleEnum) => {
        if (!email) {
            setStatus("idle");
            setNickname(null);
            return;
        }
        checkEmailMutation.mutate({ email, tenant_id: tenantId, role });
    };

    const resetStatus = () => {
        setStatus("idle");
        setNickname(null);
    };

    return {
        status,
        nickname,
        isCheckingEmail: checkEmailMutation.isPending,
        checkEmail,
        resetStatus,
    };
}
